export const getIntegerRange = (start: number, end: number) => {
  if (start > end) {
    [start, end] = [end, start]; // Swap start and end if start is greater than end
  }

  return Array.from({ length: end - start + 1 }, (_, index) => start + index);
};
